import LayoutV2 from "containers/LayoutV2";
import SearchForm from "./SearchForm";
import PhanTrang from "components/CommonComponent/PhanTrang";
import DanhSachCauHinhTaiSanTable from "./DanhSachCauHinhTaiSanTable";
import React, { useEffect, useState, useRef } from "react";
import UserApi from "service/userApi";
import "react-dropdown/style.css";
import CauHinhTaiSanApi from "service/CauHinhTaiSanApi";
import MenuChucNang from "./MenuChucNang";
import ThemSuaCauHinh from "./ChucNang/ThemSuaCauHinh";
import XoaCauHinh from "./ChucNang/XoaCauHinh";
import '../../../assets/css/table-kydonglai.css';
import ThayDoiTrangThai from "./ChucNang/ThayDoiTrangThai";
import ConfigSystemApi from "service/QuanTriHeThong/CauHinhTinhLaiVaHeThong/ConfigSystemApi";
import cauHinh from "utils/cauHinh";
import CauHinhApi from "service/cauHinhApi";
import ConfigConst from "constants/ConfigConst";

const CauHinhTaiSan = () => {
    const [loading, setLoading] = useState(true);
    const [dataResponse, setdataResponse] = useState([]);
    const [showModel, setShowModel] = useState(false);
    const [hasPermission, setHasPermission] = useState(null);
    const [RoleThemMoiCauHinhTaiSan, setRoleThemMoiCauHinhTaiSan] = useState(null);
    const [RoleSuaCauHinhTaiSan, setRoleSuaCauHinhTaiSan] = useState(null);
    const [RoleXoaCauHinhTaiSan, setRoleXoaCauHinhTaiSan] = useState(null);
    const [RoleKhoaCauHinhTaiSan, setRoleKhoaCauHinhTaiSan] = useState(null);
    const [RoleMoCauHinhTaiSan, setRoleMoCauHinhTaiSan] = useState(null);
    const [editingItem, setEditingItem] = useState(null);
    const [deleteItem, setDeleteItem] = useState(null);
    const [showXoaCauHinh, setShowXoaCauHinh] = useState(false);
    const [showCapNhatTrangThai, setShowCapNhatTrangThai] = useState(false);
    const [changeStatusItem, setChangeStatusItem] = useState(null);
    const [isCauHinhT77, setIsCauHinhT77] = useState(false);
    const [isTongSoNgay, setIsTongSoNgay] = useState(false);

    const [RoleCauhinhGiamTru, setRoleCauHinhGiamTru] = useState(null);

    const SearchData = useRef({
        sTenHangHoa: "",
        sStatus: "",
        pageIndex: 1,
        pageSize: 25,
    });

    useEffect(() => {
        document.title = "Cấu hình tài sản | Phần mềm quản lý cầm đồ - Morman";
        fetchPermission();
    }, []);

    const fetchPermission = async () => {
        try {
            const res = await UserApi.getAllQuyen();
            const roles = res.data.map((item) => item.ModuleCode.toLowerCase());
            setHasPermission(roles.includes("cauhinhtaisan"));
            setRoleThemMoiCauHinhTaiSan(roles.includes("cauhinhtaisan_themmoicauhinhtaisan"));
            setRoleSuaCauHinhTaiSan(roles.includes("cauhinhtaisan_suacauhinhtaisan"));
            setRoleXoaCauHinhTaiSan(roles.includes("cauhinhtaisan_xoacauhinhtaisan"));
            setRoleKhoaCauHinhTaiSan(roles.includes("cauhinhtaisan_khoacauhinhtaisan"));
            setRoleMoCauHinhTaiSan(roles.includes("cauhinhtaisan_mocauhinhtaisan"));
        } catch (err) {
            console.error("Lỗi load quyền:", err);
            setHasPermission(false);
            setRoleThemMoiCauHinhTaiSan(false);
            setRoleSuaCauHinhTaiSan(false);
            setRoleXoaCauHinhTaiSan(false);
            setRoleKhoaCauHinhTaiSan(false);
            setRoleMoCauHinhTaiSan(false);
        }
        try {
            const res = await ConfigSystemApi.GetConfigSystemByKeyConfig({ key: "SUDUNG_THAMDINHTAISAN" });
            try {
                if(res.data === "True"){
                    setRoleCauHinhGiamTru(true);
                }
                else{
                    setRoleCauHinhGiamTru(false);
                }
            }
            catch {
                setRoleCauHinhGiamTru(false);
            }
        }
        catch {
            setRoleCauHinhGiamTru(false);
        }
        try {
            const res = await ConfigSystemApi.GetConfigSystemByKeyConfig({ key: cauHinh.sKey.IsCauHinhT77 });
            const value = res.data;
            setIsCauHinhT77(value === true || value === "True" || value === "true" || value === "1" || value === 1);
        }
        catch {
            setIsCauHinhT77(false);
        }
        try {
            const res = await CauHinhApi.getConfig();
            const config = res.data?.[0];
            const tongSoNgay = !!config?.IsTongSoNgay && config.OptionTinhLai !== ConfigConst.ShowDate;
            setIsTongSoNgay(tongSoNgay);
        }
        catch (err) {
            setIsTongSoNgay(false);
        }
    };
    const onSearch = async (data,page) => {
        try {
            setLoading(true);
            // SearchForm gửi kèm pageSize riêng → luôn lấy pageSize đang chọn
            SearchData.current = {
                ...data,
                pageIndex: page,
                pageSize: SearchData.current.pageSize,
            };
            const res = await CauHinhTaiSanApi.SelectByPage(SearchData.current);
            setdataResponse(res.data || []);
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        } catch (error) {
            console.error("Lỗi load danh sách cấu hình tài sản:", error);
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        if (hasPermission) {
            onSearch(SearchData.current,1);
        }
    }, [hasPermission]);

    const handlePageChange = async (pageNumber) => {
        onSearch(SearchData.current,pageNumber);
    };
    const handlePageSizeChange = (pageSize) => {
        SearchData.current = { ...SearchData.current, pageSize };
        onSearch(SearchData.current, 1);
    };
    const btnThemMoiCauHinhTaiSanClick = () => {
        setEditingItem({
            CauHinhTaiSanId: 0,
            TenHangHoa: "",
            MaHangHoa: "",
            TrangThaiHangHoa: 0,
            ThuocTinhTaiSan: [],
        })
        setShowModel(true);
    }

    const btnSuaCauHinhTaiSanClick = (data) => {
        setEditingItem(data);
        setShowModel(true);
    }
    const btnXoaCauHinhClick = (CauHinhId) => {
        setDeleteItem(CauHinhId);
        setShowXoaCauHinh(true);
    }
    const btnCapNhatTrangThaiClick = (item) => {
        setChangeStatusItem(item);
        setShowCapNhatTrangThai(true);
    }
    if (hasPermission === null) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div className="loader loader-default is-active"></div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }

    if (hasPermission === false) {
        return (
            <LayoutV2>
                <h2 className="text-danger">
                    <div className="custom-table-row">
                        <div
                            className="custom-table-cell text-center red"
                            style={{ width: "100%" }}
                        >
                            Bạn không có quyền truy cập trang này!
                        </div>
                    </div>
                </h2>
            </LayoutV2>
        );
    }
    return (
        <LayoutV2>
            <div id="form-repeater">
                <div className="sticky-moman-bh">
                    <div className="col-12">
                        <div className="camdo-home">
                            <div className="breadcrumb-new">
                                <div className="row">
                                    <div className="col-sm-12 col-md-12 title-cd">
                                        <div className="media-home align-center-home">
                                            <div className="row header">
                                                <img
                                                    src="/app-assets/images/icon-cau-hinh-tai-san.png"
                                                    alt="logo"
                                                    style={{ maxWidth: "30px" }}
                                                />
                                                <h1 className="text-info-home">Quản trị hệ thống - Cấu hình tài sản</h1>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="card border-light mb-3 show-table-main card-v2"
                                style={{}}
                            >
                                <div className="card-body card-body-v2">
                                    <SearchForm
                                        onSearch={onSearch}
                                    />
                                </div>
                            </div>
                            {loading && (<>
                                <div className="loader loader-default is-active"></div>
                            </>)}
                            {!loading && (<>
                                <div
                                    className="card border-light mb-3 card-v2"
                                    style={{ marginTop: "-35px" }}
                                >
                                    <div className="card-body card-body-v2" style={{ userSelect: "text" }}>
                                        <div className="card-body card-body-v2" style={{ display: RoleThemMoiCauHinhTaiSan ? "block" : "none", marginTop: "-5px", marginBottom: "10px", maxHeight: "54px" }}>
                                            <MenuChucNang
                                                RoleThemMoiCauHinhTaiSan={RoleThemMoiCauHinhTaiSan}
                                                btnThemMoiCauHinhTaiSanClick={btnThemMoiCauHinhTaiSanClick}
                                            />
                                        </div>
                                        <DanhSachCauHinhTaiSanTable
                                            list={dataResponse}
                                            pageIndex={SearchData.current.pageIndex}
                                            pageSize={SearchData.current.pageSize}
                                            RoleSuaCauHinhTaiSan={RoleSuaCauHinhTaiSan}
                                            RoleXoaCauHinhTaiSan={RoleXoaCauHinhTaiSan}
                                            RoleKhoaCauHinhTaiSan={RoleKhoaCauHinhTaiSan}
                                            RoleMoCauHinhTaiSan={RoleMoCauHinhTaiSan}
                                            btnCapNhatTrangThaiClick={btnCapNhatTrangThaiClick}
                                            btnXoaCauHinhClick={btnXoaCauHinhClick}
                                            btnSuaCauHinhTaiSanClick={btnSuaCauHinhTaiSanClick}
                                            RoleCauhinhGiamTru = {RoleCauhinhGiamTru}
                                            isCauHinhT77={isCauHinhT77}
                                        />
                                    </div>
                                </div>
                                <div
                                    className="card border-light mb-3 card-v2"
                                    style={{
                                        marginTop: "-35px",
                                    }}
                                >
                                    <div
                                        className="card-body card-body-v2"
                                        style={{ display: dataResponse.iTotal === 0 ? "none" : "block" }}
                                    >
                                        <PhanTrang
                                            pageIndex={SearchData.current.pageIndex}
                                            pageSize={SearchData.current.pageSize}
                                            totalCount={dataResponse.iTotal}
                                            onPageChange={handlePageChange}
                                            onPageSizeChange={handlePageSizeChange}
                                        />
                                    </div>
                                </div>
                            </>)}
                        </div>
                    </div>
                </div>
                {showCapNhatTrangThai && (<ThayDoiTrangThai
                    data={changeStatusItem}
                    onClose={() => setShowCapNhatTrangThai(false)}
                    onSearch={()=>onSearch(SearchData.current,1)}
                />)}
                {showXoaCauHinh && (<XoaCauHinh
                    CauHinhId={deleteItem}
                    onClose={() => setShowXoaCauHinh(false)}
                    onSearch={()=>onSearch(SearchData.current,1)}
                />)}

                {showModel && (<ThemSuaCauHinh
                    onClose={() => setShowModel(false)}
                    onSearch={()=>onSearch(SearchData.current,1)}
                    data={editingItem}
                    isCauHinhT77={isCauHinhT77}
                    isTongSoNgay={isTongSoNgay}
                />)}
            </div>  
        </LayoutV2 >
    );
}

export default CauHinhTaiSan;
